import _defineProperty from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
var ClickedOutside = /*#__PURE__*/function (_Component) {
  function ClickedOutside() {
    var _this;
    _classCallCheck(this, ClickedOutside);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _possibleConstructorReturn(_this, (_this = _callSuper(this, ClickedOutside, [].concat(args)), _this.handleClickOutside = function (_ref) {
      var target = _ref.target;
      var hasIgnoreClass = target.classList.contains(IGNORE_CLASS_NAME);
      if (hasIgnoreClass) {
        return;
      }
      var shouldIgnoreClickOutside = _this.props.disableOnClickOutside ? _this.props.disableOnClickOutside : false;
      if (shouldIgnoreClickOutside) {
        return;
      }
      var outsideOfSelf = _this.wrapperRef && !_this.wrapperRef.contains(target);
      if (outsideOfSelf) {
        _this.props.handleClickOutside();
      }
    }, _assertThisInitialized(_this)));
  }
  _inherits(ClickedOutside, _Component);
  return _createClass(ClickedOutside, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      // In this piece of code I'm trying to get to the first not functional component
      // Because it wouldn't work if use a functional component (like <Fade/> from react-reveal)
      var firstNotFunctionalComponent = this.props.children;
      while (typeof firstNotFunctionalComponent.type === 'function') {
        firstNotFunctionalComponent = firstNotFunctionalComponent.props.children;
      }
      var children = /*#__PURE__*/React.cloneElement(firstNotFunctionalComponent, _objectSpread({
        ref: function ref(node) {
          _this2.wrapperRef = node;
        }
      }, firstNotFunctionalComponent.props));
      return __jsx(React.Fragment, null, children);
    }
  }]);
}(Component);
export { ClickedOutside as default };